import { render, staticRenderFns } from "./EmptyCoupon.vue?vue&type=template&id=2091f8d0&scoped=true&"
import script from "./EmptyCoupon.vue?vue&type=script&lang=js&"
export * from "./EmptyCoupon.vue?vue&type=script&lang=js&"
import style0 from "./EmptyCoupon.vue?vue&type=style&index=0&id=2091f8d0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2091f8d0",
  null
  
)

export default component.exports